import { Check, Palette } from "lucide-react";
import { ACCENTS, THEMES } from "../lib/theme";

export default function ThemeCenter({ settings, onChange }) {
  return (
    <section className="panel-page theme-page">
      <header className="section-header safe-top">
        <div>
          <h1>Theme Center</h1>
          <p>Save camera overlay, editor, AI panel, and accent preferences offline.</p>
        </div>
        <Palette size={34} />
      </header>
      <h2>Themes</h2>
      <div className="theme-grid">
        {THEMES.map((theme) => (
          <button
            key={theme.id}
            type="button"
            className={`theme-card ${settings.theme === theme.id ? "is-active" : ""}`}
            onClick={() => onChange({ theme: theme.id })}
            style={{ background: theme.values.bg, color: theme.values.text, borderColor: theme.values.border }}
          >
            <span>{theme.name}</span>
            <small style={{ background: theme.values.panelStrong }} />
            {settings.theme === theme.id && <Check size={18} />}
          </button>
        ))}
      </div>
      <h2>Accent</h2>
      <div className="accent-grid">
        {Object.entries(ACCENTS).map(([name, color]) => (
          <button key={name} type="button" onClick={() => onChange({ accent: name })} className={settings.accent === name ? "is-active" : ""}>
            <span style={{ background: color }} />
            {name}
          </button>
        ))}
      </div>
      <h2>Motion</h2>
      <div className="segmented">
        {["full", "reduced", "none"].map((motion) => (
          <button key={motion} className={settings.motion === motion ? "is-active" : ""} type="button" onClick={() => onChange({ motion })}>{motion}</button>
        ))}
      </div>
    </section>
  );
}
